import { Injectable } from '@angular/core';
import { VideoPlaylist } from '@hsi/video-playlist';
import { BehaviorSubject } from 'rxjs';

export interface MessageOptions {
  text: string;
  actionText?: string;
  duration: number;
}

@Injectable({
  providedIn: 'root'
})
export class AppUtilityService {
  loadingIndicator: any = { api: null };
  showProgressBar$ = new BehaviorSubject<boolean>(false);

  displayMessage(options: MessageOptions): void {
    const notice = new window.mdc.snackbar.MDCSnackbar(document.querySelector('.mdc-snackbar'));
    notice.labelText = options.text;
    notice.actionButtonText = options.actionText || 'OK';
    notice.timeoutMs = options.duration;
    notice.open();
  }

  resolveVideoQuality(): any {
    let videoQuality = VideoPlaylist.Core.Services.AvailableFormat.MEDIUM;
    if (localStorage.getItem('videoQuality') === 'hd')
      videoQuality = VideoPlaylist.Core.Services.AvailableFormat.HIGH;
    else if (localStorage.getItem('videoQuality') === 'sd')
      videoQuality = VideoPlaylist.Core.Services.AvailableFormat.STANDARD;
    return videoQuality;
  }

  showProgressBar() {
    this.showProgressBar$.next(true);
  }

  hideProgressBar() {
    this.showProgressBar$.next(false);
  }

  removeOldServiceWorker(): void {
    // Delete video player caches
    caches.keys().then(keys => {
      keys.forEach(key => {
        if (key.includes('hsi-video-player-precache-v2') || key === 'hsi-microservices') {
          caches.delete(key);
        }
      });
    });

    // Unregister old service workers
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(registration => {
        if (registration.active && registration.active.scriptURL.includes('service-worker.js')) {
          registration.unregister();
        }
      });
    });
  }
}